<template>
    <div class="cooperate">
        <menuBox :step="6"></menuBox>
        <div class="cooperate-box">
            <div class="title">合作機構</div>
            <div class="cooperate-img">
                <!-- <img src="../assets/icon-1.png" alt="">
                <img src="../assets/icon-11.png" alt="">
                <img src="../assets/icon-12.png" alt=""> -->
                <img src="../assets/icon-2.png" alt="">
                <img src="../assets/icon-9.png" alt="">
                <img src="../assets/icon-13.png" alt="">
                <img src="../assets/icon-5.png" alt="">
                <img src="../assets/icon-6.png" alt="">
                <img src="../assets/icon-8.png" alt="">
                <img src="../assets/icon-16.png" alt="">
                <img src="../assets/icon-14.png" alt="">
                <img src="../assets/icon-7.png" alt="">
                <img src="../assets/icon-10.png" alt="">
                <img src="../assets/icon-15.png" alt="">
                <img src="../assets/icon-4.png" alt="">
                <!-- <img src="../assets/icon-17.png" alt=""> -->
            </div>
        </div>
        <footerBox></footerBox>
    </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
    name: 'App',
    components: {
        menuBox,
        footerBox,
    },
    data() {
        return {
        }
    },
    mounted() {

    },
    methods: {

    }
}
</script>
<style lang="less" scoped>
.cooperate-box {
    padding: 0px 325px;
    .title {
        font-size: 64px;
        font-weight: 500;
        color: #333333;
        margin-top: 179px;
        text-align: center;
    }
    .cooperate-img{
        display: flex;
        flex-flow: wrap;
        padding: 71px 0px 105px 0px;
        align-items: center;
        justify-content: space-between;
        img{
            width: 310px;
            height: 150px;
        }
    }
}
</style>